class BtpFaq extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.btp-pb__faq-toggle').forEach(toggle => {
      toggle.addEventListener('click', () => this._handleToggle(toggle));
    });
  }

  _handleToggle(toggle) {
    const item = toggle.closest('.btp-pb__faq-item');
    const isOpen = item.classList.contains('is-open');
    this.querySelectorAll('.btp-pb__faq-item').forEach(i => {
      i.classList.remove('is-open');
      i.querySelector('.btp-pb__faq-toggle').setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  }
}

if (!customElements.get('btp-faq')) {
  customElements.define('btp-faq', BtpFaq);
}
